// src/pages/MakeCall.js
import React, { useState, useEffect } from "react";
import { Container, Alert, Badge } from "react-bootstrap";
import { useSoftphone } from "../context/SoftphoneContext";
import { useSearchParams, useNavigate } from "react-router-dom";


const audioCache = {};

const playTone = (digit) => {
  const map = {
    "*": "star",
    "#": "hash",
  };

  const fileName = map[digit] || digit; // convert * → star, # → hash
  const filePath = `/sounds/tone_${fileName}.wav`;

  if (!audioCache[filePath]) {
    audioCache[filePath] = new Audio(filePath);
  }

  const audio = audioCache[filePath];
  audio.currentTime = 0;
  audio.play().catch(() => {});
};
const COUNTRY_CODES = ["+1", "+44", "+91", "+61"];

const splitCountryCode = (fullNumber) => {
  for (const code of COUNTRY_CODES) {
    if (fullNumber.startsWith(code)) {
      return {
        countryCode: code,
        number: fullNumber.slice(code.length),
      };
    }
  }
  return {
    countryCode: "+1",
    number: fullNumber.replace(/^\+/, ""),
  };
};

function MakeCall({ user }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [toNumber, setToNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+1");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [isSpeaker, setIsSpeaker] = useState(false);
  const [callingNumber, setCallingNumber] = useState(""); // Store full number during call

  const { softphoneStatus, makeTwilioCall, activeCall, hangUp } =
    useSoftphone();

  const countryCodes = [
    { code: "+1", name: "USA" },
    { code: "+44", name: "UK" },
    { code: "+91", name: "IND" },
    { code: "+61", name: "AU" },
    // Add more countries as needed
  ];

  const dialPad = [
    { d: "1" },
    { d: "2" },
    { d: "3" },
    { d: "4" },
    { d: "5" },
    { d: "6" },
    { d: "7" },
    { d: "8" },
    { d: "9" },
    { d: "*" },
    { d: "0" },
    { d: "#" },
  ];


useEffect(() => {
  const numberFromContacts = searchParams.get("number");
  if (!numberFromContacts) return;

  const cleaned = numberFromContacts.replace(/[^\d+]/g, "");

  const { countryCode, number } = splitCountryCode(cleaned);

  setCountryCode(countryCode); // ✅ auto select country
  setToNumber(number);         // ✅ only local number
}, [searchParams]);



  // const handleMakeCall = async () => {
  //   if (!toNumber.trim()) return;
  //   const fullNumber = toNumber.startsWith("+")
  //     ? toNumber
  //     : `${countryCode}${toNumber}`;
  //   setCallingNumber(fullNumber); // store full number for display during call
  //   setMessage("");
  //   try {
  //     const connection = await makeTwilioCall(fullNumber);//new added
  //     // await makeTwilioCall(fullNumber);
  //     await connection.setSinkId("communications"); //new added
  //     setIsSpeaker(false); // new added
  //     setMessage(`Call initiated to ${fullNumber}. Connecting...`);
  //     setMessageType("info");
  //     setToNumber(""); // clear input after storing number
  //   } catch (error) {
  //     setMessage(error.message || "Failed to start call.");
  //     setMessageType("danger");
  //   }
  // };
    const handleMakeCall = async () => {
  if (!toNumber.trim()) return;

  const fullNumber = toNumber.startsWith("+")
    ? toNumber
    : `${countryCode}${toNumber}`;

  setCallingNumber(fullNumber);
  setMessage("");
  setMessageType("");

  try {
    // 1. Get the Twilio Connection object (must return it from makeTwilioCall)
    const connection = await makeTwilioCall(fullNumber);

    // 2. Force earpiece when call is accepted
    connection.on("accept", async () => {
      try {
        if (typeof connection.setSinkId === "function") {
          await connection.setSinkId("default"); // earpiece
        }
        setIsSpeaker(false);
        setMessage(`Call connected to ${fullNumber}`);
        setMessageType("success");
      } catch (err) {
        console.warn("setSinkId failed (normal on iOS/desktop):", err);
      }
    });

    // Show connecting state
    setMessage(`Call initiated to ${fullNumber}. Connecting...`);
    setMessageType("info");
    setToNumber(""); // clear input
  } catch (error) {
    setMessage(error.message || "Failed to start call.");
    setMessageType("danger");
  }
};
  const handleDialPad = (value) => {
    playTone(value); // 🔊 play keypad tone
    if (value === "backspace") {
      setToNumber((prev) => prev.slice(0, -1));
    } else {
      setToNumber((prev) => prev + value);
    }
  };

  // const toggleSpeaker = () => {
  //   setIsSpeaker((prev) => !prev);
  //   // TODO: integrate actual softphone speaker toggle if supported
  //   // e.g., softphone.setSpeaker(isSpeaker)
  // };
  const { toggleAudio, isEarpiece } = useSoftphone();

const toggleSpeaker = () => {
  toggleAudio(); // This will switch earpiece <-> speaker
};


  return (
    <Container
      fluid
      className="d-flex flex-column justify-content-between align-items-center  px-3 mainWrapper"
      style={{
        maxWidth: "400px",
        margin: "0 auto",
        backgroundColor: "#f1f3f5",
      }}
    >
      {/* Header */}
      <div className="w-100 d-flex align-items-center justify-content-between mb-3">
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
          onClick={() => navigate('/calls')}
        >
          <i className="fas fa-arrow-left"></i>
          <span>Calls</span>
        </button>
        <div className="text-center flex-grow-1 me-4">
          <h4 className="fw-bold mb-0">Protected Dialer</h4>
          <p className="text-muted small mb-0">Your number stays hidden</p>
        </div>
      </div>

      {/* Number Display + Country Code or Calling */}
      <div className="d-flex w-100 align-items-center gap-2">
  {!activeCall ? (
    <>
      {/* NEW COUNTRY CODE UI */}
      <div className="position-relative">
        <button
          type="button"
          className="bg-light border rounded-2 px-3 py-1 text-start d-flex align-items-center gap-2"
          style={{ minWidth: "80px" }}
          onClick={(e) => e.target.nextSibling && e.target.nextSibling.focus()}
        >
          <span className="fw-medium">{countryCode}</span>
          <i className="fas fa-chevron-down ms-auto small"></i>
        </button>

        <select
          className="position-absolute top-0 start-0 w-100 h-100 opacity-0"
          style={{ cursor: "pointer" }}
          value={countryCode}
          onChange={(e) => setCountryCode(e.target.value)}
        >
          {countryCodes.map((c) => (
            <option key={c.code} value={c.code}>
              {c.name} ({c.code})
            </option>
          ))}
        </select>
      </div>

      {/* Number display */}
      <h2 className="fs-5 fw-normal text-dark mb-0 bg-light border rounded-2 px-2 py-1 flex-fill">
        {toNumber || "Enter number"}
      </h2>
    </>
  ) : (
    /* calling UI unchanged */
    <>
      <h2 className="display-6 fw text-dark">Calling...</h2>
      <p className="text-muted small mt-1">{callingNumber}</p>
    </>
  )}
</div>
        <Badge bg="success" pill className="mt-2 mb-3 px-3 py-2">
          <i className="fas fa-shield-alt me-1"></i> Privacy Protected
        </Badge>
      {/* Dial Pad */}
      {!activeCall && (
        <div
          className="d-grid gap-3 mb-4"
          style={{ gridTemplateColumns: "repeat(3, 1fr)", width: "100%" }}
        >
          {dialPad.map(({ d }) => (
            <button
              key={d}
              type="button"
              className="btn btn-light rounded-circle shadow-sm d-flex align-items-center justify-content-center"
              style={{
                width: "4rem",
                height: "4rem",
                fontSize: "1.5rem",
                fontWeight: "500",
                margin: "0 auto",
              }}
              onClick={() => handleDialPad(d)}
            >
              {d}
            </button>
          ))}
        </div>
      )}

      {/* Action Buttons */}
      <div className="d-flex justify-content-between align-items-center w-100 px-5">
        {/* Backspace - only when no active call */}
        {!activeCall && (
          <button
            type="button"
            className="btn btn-light rounded-circle shadow-sm"
            style={{ width: "60px", height: "60px" }}
            onClick={() => handleDialPad("backspace")}
            disabled={!toNumber}
          >
            <i className="fas fa-backspace text-muted"></i>
          </button>
        )}

        {/* Call / Hangup */}
        {activeCall ? (
          <>
            {/* Hang Up */}
            <button
              type="button"
              className="btn btn-danger rounded-circle shadow-lg d-flex align-items-center justify-content-center"
              style={{ width: "4rem", height: "4rem" }}
              onClick={hangUp}
            >
              <i className="fas fa-phone-slash text-white"></i>
            </button>

            {/* Speaker / Earpiece */}
            <button
              type="button"
              className="btn btn-light rounded-circle shadow-sm d-flex align-items-center justify-content-center"
              style={{ width: "60px", height: "60px" }}
              onClick={toggleSpeaker}
            >
              <i className={`fas ${!isEarpiece ? "fa-volume-high" : "fa-volume-low"} text-primary`}></i>
            </button>
          </>
        ) : (
          // Call button when no active call
          <button
            type="button"
            className="btn btn-success rounded-circle shadow-lg d-flex align-items-center justify-content-center"
            style={{ width: "4rem", height: "4rem" }}
            onClick={handleMakeCall}
            disabled={!toNumber}
          >
            <i className="fas fa-phone text-white"></i>
          </button>
        )}

        {/* Empty space for alignment */}
        {!activeCall && <div style={{ width: "60px" }}></div>}
      </div>

      {/* Message */}
      {/* {message && (
        <Alert variant={messageType} className="text-center w-100">
          {message}
        </Alert>
      )} */}
    </Container>
  );
}

export default MakeCall;
